<template>
  <div class="safe-custody-info">
    <div id="about" class="safe-custody-info-about">
      <div class="public-container-mobile">
        <div v-html="content.blocks?.about.description" />
        <div class="public-text-line mt-20">
          {{ content.blocks?.about.attention }}
        </div>
      </div>
      <div class="safe-custody-info-about-image">
        <strong>{{ content.blocks?.about.cardTitle }}</strong>
        <p>{{ content.blocks?.about.cardText }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {getPageContent} from '~/api/content';

const content = await getPageContent('/safe-custody')
</script>

<style scoped lang="scss">
.safe-custody-info {
  margin-top: 70px;

  &-about {
    display: flex;
    margin-bottom: 110px;

    &-image {
      background-image: url("/images/pages/safe-custody/safe-storage.png");
      width: 610px;
      min-width: 610px;
      height: 330px;
      margin-left: 20px;
      padding: 0 260px 0 50px;
      color: #FF6F50;
      display: flex;
      flex-direction: column;
      justify-content: center;

      strong {
        text-transform: uppercase;
        font-size: 34px;
        line-height: 40px;
        font-weight: 900;
      }
      p {
        font-size: 24px;
        line-height: 28px;
        font-weight: 500;
        margin-top: 10px;
      }
    }
    :deep(p) {
      margin-bottom: 5px;
    }
  }

  @media screen and (max-width: $pub-md) {
    &-about {
      margin-bottom: 90px;
      &-image {
        width: 513px;
        min-width: 513px;
        height: 280px;
        background-size: contain;
        padding-left: 40px;
        padding-right: 220px;

        strong {
          font-size: 28px;
          line-height: 36px;
        }
        p {
          font-size: 20px;
          line-height: 26px;
        }
      }
    }
  }

  @media screen and (max-width: $pub-sm) {
    &-about {
      &-image {
        background-image: url("/images/pages/safe-custody/safe-storage-mobile.png");
        width: 300px;
        min-width: 300px;
        height: 465px;
        justify-content: start;
        padding: 30px 40px;

        strong {
          font-size: 26px;
          line-height: 34px;
        }
        p {
          font-size: 18px;
          line-height: 24px;
        }
      }
    }
  }

  @media screen and (max-width: $pub-xs) {
    &-about {
      flex-direction: column;
      align-items: center;
      margin-bottom: 70px;
      &-image {
        width: 100%;
        max-width: 320px;
        min-width: unset;
        height: 500px;
        margin-left: 0;
        margin-top: 40px;
      }
    }
  }
}
</style>
